export enum DataLayerCustomDimensions {
  Event = 'event',
  VirtualPath = 'virtPath',
  Language = 'language',
  Country = 'country',
  PageType = 'pageType',
  PageSubType = 'pageSubType',
  PageTitle = 'pageTitle',
  PageName = 'pageName',
  PageLanguage = 'pageLanguage',
  ContentSection1 = 'contentSection1',
  ContentSection2 = 'contentSection2',
  ContentSection3 = 'contentSection3',
  Environment = 'environment',
  UserID = 'userID'
}

export const DataLayer_PT_Home = {
  [DataLayerCustomDimensions.PageName]: '/uptop/{competition}/home/',
  [DataLayerCustomDimensions.PageType]: 'hub',
  [DataLayerCustomDimensions.PageSubType]: 'resource list',
};

export const DataLayer_PT_StadiumDetails = {
  [DataLayerCustomDimensions.PageName]: '/uptop/{competition}/stadium/',
  [DataLayerCustomDimensions.PageType]: '360',
  [DataLayerCustomDimensions.PageSubType]: 'stadium cameras',
  [DataLayerCustomDimensions.ContentSection3]: 'stadium',
};

export const DataLayer_PT_StadiumDetailsCamera = {
  [DataLayerCustomDimensions.PageName]: '/uptop/{competition}/stadium/details/',
  [DataLayerCustomDimensions.PageType]: 'details',
  [DataLayerCustomDimensions.PageSubType]: 'stadium cameras',
  [DataLayerCustomDimensions.VirtualPath]: '/vp/uptop/{competition}/stadium/details/',
  [DataLayerCustomDimensions.Event]: 'virtPath',
  [DataLayerCustomDimensions.ContentSection3]: 'stadium',
};

export const DataLayer_PT_StoryboardDetail = {
  [DataLayerCustomDimensions.PageName]: '/uptop/{competition}/storyboards/{howtosection}/',
  [DataLayerCustomDimensions.PageType]: 'video playlist',
  [DataLayerCustomDimensions.PageSubType]: 'tutorial',
  [DataLayerCustomDimensions.ContentSection3]: 'storyboard',
};

export const DataLayer_PT_StoryboardDetailVP = {
  [DataLayerCustomDimensions.PageName]: '/uptop/{competition}/storyboards/{howtosection}/',
  [DataLayerCustomDimensions.PageType]: 'video playlist',
  [DataLayerCustomDimensions.PageSubType]: 'tutorial',
  [DataLayerCustomDimensions.ContentSection3]: 'storyboard',
  [DataLayerCustomDimensions.VirtualPath]: '/vp/uptop/{competition}/storyboards/{howtosection}/',
  [DataLayerCustomDimensions.Event]: 'virtPath',
};

export const DataLayer_PT_StoryboardList = {
  [DataLayerCustomDimensions.PageName]: '/uptop/{competition}/storyboards/',
  [DataLayerCustomDimensions.PageType]: 'list',
  [DataLayerCustomDimensions.PageSubType]: 'tutorial',
  [DataLayerCustomDimensions.ContentSection3]: 'storyboard',
};

export const DataLayer_PT_TopicCategory = {
  [DataLayerCustomDimensions.PageName]: '/uptop/{competition}/topics/{topiccategory}/',
  [DataLayerCustomDimensions.PageType]: 'list',
  [DataLayerCustomDimensions.PageSubType]: 'topics',
  [DataLayerCustomDimensions.ContentSection3]: 'topics',
};

export const DataLayer_PT_TopicDetail = {
  [DataLayerCustomDimensions.PageName]: '/uptop/{competition}/topics/{topiccategory}/{topicname}/',
  [DataLayerCustomDimensions.PageType]: 'detail',
  [DataLayerCustomDimensions.PageSubType]: 'video',
  [DataLayerCustomDimensions.ContentSection3]: 'topics',
};

export const DataLayer_PT_FileDetail = {
  [DataLayerCustomDimensions.PageName]: '/uptop/{competition}/files/{filename}/',
  [DataLayerCustomDimensions.PageType]: 'detail',
  [DataLayerCustomDimensions.PageSubType]: 'document',
  [DataLayerCustomDimensions.ContentSection3]: 'files',
};
